__turbopack_context__.v({
  "box": "change-password-module-scss-module__avCSWa__box",
  "container": "change-password-module-scss-module__avCSWa__container",
  "modal": "change-password-module-scss-module__avCSWa__modal",
  "modal__buttons": "change-password-module-scss-module__avCSWa__modal__buttons",
  "modal__header": "change-password-module-scss-module__avCSWa__modal__header",
});
